import WhiteLogo from "@/components/icons/WhiteLogo";

const FinalStepContentPreview = () => {
  return (
    <div className="bg-primary lg:rounded-[20px] shadow-md p-6 lg:p-10 text-white flex flex-col lg:items-center justify-center h-[calc(100%-0.5rem)] object-cover lg:mt-1">
      <WhiteLogo />
      <img className="h-auto" src="/success-page.svg" alt="group-icon" />
    </div>
  );
};

export default FinalStepContentPreview;
